import { AutogenModelDomainAction, AutogenRowDomainAction } from "./autogen/AutogenModelDomainAction";

export class ModelDomainAction extends AutogenModelDomainAction<RowDomainAction> {
	constructor() {
		super(RowDomainAction);
	}
}

export class RowDomainAction extends AutogenRowDomainAction {
}